var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenIncognitoTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6112_100720)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 29,
    height: 29,
    rx: 5,
    fill: "#43AC43"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7361 10.7579L13.8445 14.0272C13.8392 14.0466 13.8345 14.0659 13.8304 14.0853C12.1129 14.3587 11 14.7966 11 15.2903C11 16.1187 14.134 16.7903 18 16.7903C21.866 16.7903 25 16.1187 25 15.2903C25 14.7966 23.8871 14.3587 22.1696 14.0853C22.1655 14.0659 22.1608 14.0466 22.1555 14.0272L21.2639 10.7579C21.1183 10.224 20.5664 9.90863 20.0251 10.0236C19.4111 10.1539 18.6204 10.2903 18 10.2903C17.3796 10.2903 16.5889 10.1539 15.9749 10.0236C15.4336 9.90863 14.8817 10.224 14.7361 10.7579ZM14.7513 14.625C14.7653 14.4876 14.888 14.3876 15.0253 14.4016C15.9255 14.4932 16.9342 14.5446 18 14.5446C19.0658 14.5446 20.0745 14.4932 20.9747 14.4016C21.112 14.3876 21.2347 14.4876 21.2487 14.625C21.2627 14.7623 21.1627 14.885 21.0253 14.899C20.107 14.9925 19.0814 15.0446 18 15.0446C16.9186 15.0446 15.893 14.9925 14.9747 14.899C14.8373 14.885 14.7373 14.7623 14.7513 14.625ZM13.5 18.7903H15.5C15.7761 18.7903 16 19.0141 16 19.2903V20.2903C16 21.1187 15.3284 21.7903 14.5 21.7903C13.6716 21.7903 13 21.1187 13 20.2903V19.2903C13 19.0141 13.2239 18.7903 13.5 18.7903ZM12 19.2903C12 19.115 12.0301 18.9467 12.0854 18.7903H12C11.7239 18.7903 11.5 18.5664 11.5 18.2903C11.5 18.0141 11.7239 17.7903 12 17.7903H13.5H15.5C16.2646 17.7903 16.8957 18.3624 16.9883 19.102C17.648 18.9028 18.352 18.9028 19.0117 19.102C19.1043 18.3624 19.7354 17.7903 20.5 17.7903H22.5H24C24.2761 17.7903 24.5 18.0141 24.5 18.2903C24.5 18.5664 24.2761 18.7903 24 18.7903H23.9146C23.9699 18.9467 24 19.115 24 19.2903V20.2903C24 21.671 22.8807 22.7903 21.5 22.7903C20.1193 22.7903 19 21.671 19 20.2903V20.1507L18.7906 20.0809C18.2774 19.9098 17.7226 19.9098 17.2094 20.0809L17 20.1507V20.2903C17 21.671 15.8807 22.7903 14.5 22.7903C13.1193 22.7903 12 21.671 12 20.2903V19.2903ZM20.5 18.7903H22.5C22.7761 18.7903 23 19.0141 23 19.2903V20.2903C23 21.1187 22.3284 21.7903 21.5 21.7903C20.6716 21.7903 20 21.1187 20 20.2903V19.2903C20 19.0141 20.2239 18.7903 20.5 18.7903Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6112_100720",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6112_100720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6112_100720",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenIncognitoTableIcon);
export default __webpack_public_path__ + "static/media/green-incognito-table-icon.2a468ff00d34ce1f93dd3792fdc01f0c.svg";
export { ForwardRef as ReactComponent };